module.exports = __webpack_public_path__ + "static/media/Potregi.af573cbe.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Potregi.eot
// module id = 2962
// module chunks = 70